import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
    CollapsiblePanel,
    CollapsiblePanelBody,
    CollapsiblePanelHeader,
    HorizontalFlex,
    PadContainer,
    VerticalFlex,
} from 'smartsuite-ui';

export default function DataPanel({
    metricSourceKey,
    metricSource,
    expandAll,
}) {
    const [isCollapsed, setIsCollapsed] = useState(expandAll);

    useEffect(() => setIsCollapsed(!expandAll), [expandAll]);

    function renderMetrics(metrics) {
        if (!metrics?.length) {
            return null;
        }

        return (
            <VerticalFlex cssClassModifiers={['is-half']}>
                <PadContainer>
                    <h3>Metrics</h3>
                    <ul>
                        <PadContainer cssClassModifiers={['pad-medium']}>
                            {_.uniq(metrics).map((x) => (
                                <li>
                                    <div key={`${metricSourceKey}${x}`}>
                                        {x}
                                    </div>
                                </li>
                            ))}
                        </PadContainer>
                    </ul>
                </PadContainer>
            </VerticalFlex>
        );
    }

    function renderGroupBy(groupBy) {
        if (!groupBy?.length) {
            return null;
        }
        return (
            <VerticalFlex cssClassModifiers={['is-half']}>
                <PadContainer>
                    <h3>Grouped By</h3>
                    <ul>
                        <PadContainer cssClassModifiers={['pad-medium']}>
                            {_.uniq(groupBy).map((x) => (
                                <li>
                                    <div key={`${metricSourceKey}${x}`}>
                                        {x}
                                    </div>
                                </li>
                            ))}
                        </PadContainer>
                    </ul>
                </PadContainer>
            </VerticalFlex>
        );
    }

    if (metricSource.metrics.length === 0) {
        return null;
    }
    return (
        <CollapsiblePanel
            isCollapsed={isCollapsed}
            onCollapse={() => setIsCollapsed((prevState) => !prevState)}
        >
            <CollapsiblePanelHeader headerLabel={metricSourceKey} />
            <CollapsiblePanelBody>
                <HorizontalFlex cssClassModifiers={['align-flex-start']}>
                    {renderMetrics(metricSource.metrics)}
                    {renderGroupBy(metricSource.groupBy)}
                </HorizontalFlex>
            </CollapsiblePanelBody>
        </CollapsiblePanel>
    );
}

DataPanel.propTypes = {
    metricSourceKey: PropTypes.string,
    metricSource: PropTypes.instanceOf(Object).isRequired,
    expandAll: PropTypes.bool,
};
